import { useEffect, useRef, useState } from 'react';
import $ from 'jquery';
import { HiOutlineMail, HiOutlinePhone, HiOutlineLocationMarker, HiOutlineAcademicCap } from 'react-icons/hi';
import { FiGithub, FiLinkedin } from 'react-icons/fi';

export default function Contact() {
  const formRef = useRef(null);
  const [sent, setSent] = useState(false);

  useEffect(() => {
    // 3D floating animation on contact card
    let angle = 0;
    let raf;
    const float = () => {
      angle += 0.02;
      const y  = Math.sin(angle) * 8;
      const rx = Math.cos(angle * 0.7) * 3;
      $('.contact-card').css('transform', `perspective(1000px) translateY(${y}px) rotateX(${rx}deg)`);
      raf = requestAnimationFrame(float);
    };
    raf = requestAnimationFrame(float);

    // Clear validation error on blur when field becomes valid
    $(formRef.current).find('input, textarea').off('blur').on('blur', function () {
      validateField($(this));
    });

    // jQuery form validation on submit
    $(formRef.current).off('submit').on('submit', function (e) {
      e.preventDefault();
      let valid = true;

      // Clear previous errors
      $(this).find('.field-error').remove();
      $(this).find('.form-group').removeClass('has-error');

      // Validate each field
      $(this).find('input, textarea').each(function () {
        if (!validateField($(this))) valid = false;
      });

      if (!valid) return;

      // All valid — send via Formspree
      const $btn = $(this).find('.submit-btn');
      $btn.text('Sending…').prop('disabled', true);

      const formData = new FormData(formRef.current);
      fetch('https://formspree.io/f/xojrrejr', {
        method: 'POST',
        body: formData,
        headers: { Accept: 'application/json' },
      })
        .then(res => {
          if (res.ok) {
            setSent(true);
          } else {
            $btn.text('Failed — try again').prop('disabled', false);
          }
        })
        .catch(() => {
          $btn.text('Failed — try again').prop('disabled', false);
        });
    });

    return () => cancelAnimationFrame(raf);
  }, []);

  return (
    <section id="contact" className="contact-section">
      <h2 className="section-title">Get In <span>Touch</span></h2>
      <p className="section-sub">Open to internships, collaborations, and cool projects</p>

      <div className="contact-wrapper">
        {/* Info card */}
        <div className="contact-card">
          <h3>Contact Info</h3>
          <div className="contact-items">
            <div className="contact-item">
              <span className="c-icon"><HiOutlineMail /></span>
              <div>
                <strong>Email</strong>
                <p>zidanenaitcheikh@gmail.com</p>
              </div>
            </div>
            <div className="contact-item">
              <span className="c-icon"><HiOutlinePhone /></span>
              <div>
                <strong>Phone</strong>
                <p>+212 638 35 25 24</p>
              </div>
            </div>
            <div className="contact-item">
              <span className="c-icon"><HiOutlineLocationMarker /></span>
              <div>
                <strong>Location</strong>
                <p>Marrakech, Morocco</p>
              </div>
            </div>
            <div className="contact-item">
              <span className="c-icon"><HiOutlineAcademicCap /></span>
              <div>
                <strong>University</strong>
                <p>FSSM — Université Cadi Ayyad</p>
              </div>
            </div>
          </div>
          <div className="social-links">
            <a href="https://github.com/Zidane-Nait-cheikh" target="_blank" rel="noreferrer" className="social-btn">
              <FiGithub /> GitHub
            </a>
            <a href="https://www.linkedin.com/in/zidane-nait-cheikh/" target="_blank" rel="noreferrer" className="social-btn">
              <FiLinkedin /> LinkedIn
            </a>
          </div>
        </div>

        {/* Form */}
        <form ref={formRef} className="contact-form" noValidate>
          {sent ? (
            <div className="success-msg">
              <span>✅</span>
              <p>Message sent! I'll get back to you soon.</p>
            </div>
          ) : (
            <>
              <div className="form-group">
                <input type="text" name="name" placeholder=" " />
                <label>Your Name</label>
              </div>
              <div className="form-group">
                <input type="email" name="email" placeholder=" " />
                <label>Email Address</label>
              </div>
              <div className="form-group">
                <input type="text" name="subject" placeholder=" " />
                <label>Subject</label>
              </div>
              <div className="form-group">
                <textarea name="message" rows="5" placeholder=" " />
                <label>Message</label>
              </div>
              <button type="submit" className="submit-btn btn btn-primary">
                Send Message
              </button>
            </>
          )}
        </form>
      </div>
    </section>
  );
}

/* ── jQuery validation helper ── */
function validateField($el) {
  const val   = $el.val().trim();
  const name  = $el.attr('name');
  const $grp  = $el.closest('.form-group');
  let   msg   = '';

  if (!val) {
    msg = 'This field is required.';
  } else if (name === 'email') {
    const emailRe = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRe.test(val)) msg = 'Please enter a valid email address.';
  }

  if (msg) {
    $grp.addClass('has-error');
    if (!$grp.find('.field-error').length) {
      $grp.append(`<span class="field-error">${msg}</span>`);
    }
    return false;
  }

  $grp.removeClass('has-error').find('.field-error').remove();
  return true;
}
